import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { getCasinoReportHistory } from "../../service/casino";
import { ReportPagination, ReportToolbar } from "./ReportHelpers";

const CASINO_GAMES = [
  ["DRAGON_TIGER_20", "20-20 Dragon Tiger"], ["TEEN", "1 Day Teenpatti"],
  ["TEEN_20", "20-20 Teenpatti"], ["POKER_20", "20-20 Poker"],
  ["AB_20", "Andar Bahar"], ["lucky7", "Lucky 7"], ["baccarat", "Baccarat"],
];

export default function CasinoResult() {
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [casinoType, setCasinoType] = useState("DRAGON_TIGER_20");
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(25);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const loadReport = async (requestedPage = page, requestedSize = size) => {
    setLoading(true);
    const result = await getCasinoReportHistory({ casinoGames: casinoType, date: new Date(`${date}T00:00:00`), page: requestedPage, size: requestedSize });
    const response = result?.response || {};
    const content = Array.isArray(response) ? response : response?.content || [];
    setRows(content);
    setTotalPages(Number(response?.totalPages || (content.length ? 1 : 0)));
    setPage(requestedPage);
    setLoading(false);
  };

  useEffect(() => {
    loadReport(0);
    // Load once with the default report filters.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const visibleRows = useMemo(() => {
    const term = search.trim().toLowerCase();
    return term ? rows.filter((row) => `${row.marketId || ""} ${row.winner || ""}`.toLowerCase().includes(term)) : rows;
  }, [rows, search]);

  return (
    <div className="main standard-report-page"><div className="container-fluid"><div className="row"><div className="col-md-12 main-container"><div className="listing-grid">
      <div className="detail-row"><h2>Casino Result Report</h2><div className="report-filter-form"><div className="row">
        <div className="col-md-2 form-group"><label htmlFor="casino-result-date">Date</label><input id="casino-result-date" type="date" className="form-control" value={date} onChange={(e) => setDate(e.target.value)} /></div>
        <div className="col-md-3 form-group"><label htmlFor="casino-result-type">Casino Type</label><select id="casino-result-type" className="form-control" value={casinoType} onChange={(e) => setCasinoType(e.target.value)}>{CASINO_GAMES.map(([value, label]) => <option key={value} value={value}>{label}</option>)}</select></div>
        <div className="col-md-2 report-button-column"><button type="button" className="btn btn-diamond" disabled={loading} onClick={() => loadReport(0)}>{loading ? "Loading..." : "Submit"}</button></div>
      </div></div></div>
      <ReportToolbar size={size} search={search} onSearchChange={(e) => setSearch(e.target.value)} onSizeChange={(e) => { const next = Number(e.target.value); setSize(next); loadReport(0, next); }} />
      <div className="table-responsive data-table"><table className="table table-bordered clean-report-table"><thead><tr><th>Market ID</th><th>Winner</th></tr></thead><tbody>{visibleRows.length ? visibleRows.map((row, index) => <tr key={row.marketId || index}><td>{row.marketId || "-"}</td><td>{row.winner || "-"}</td></tr>) : <tr><td colSpan={2} className="dataTables_empty">{loading ? "Loading results..." : "No data available in table"}</td></tr>}</tbody></table></div>
      <ReportPagination page={page} totalPages={totalPages} onChange={loadReport} />
    </div></div></div></div></div>
  );
}
